import React from 'react'

import { Link } from 'gatsby'

const NavLink = ({ href, ...rest }) => {
  return <Link to={href} {...rest} />
}

export default NavLink
